export default __webpack_public_path__ + "assets/img/Segoe UI Bold Italic.04ca0df8c9e54c81b1a5b17db75c067f.woff";